import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import heroBg from "../../assets/hero-bg.png";
import "./PlatformComponent.css";
import EventService from "../../core/service/EventService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  formatEventDisplayDate,
  getEventSortDate,
  isEventPast,
  isEventWithinMonths,
} from "../../utils/eventDateUtils";

const PlatformPage = () => {
  const navigate = useNavigate();
  const eventServiceRef = useRef(new EventService());
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await eventServiceRef.current.getAllEvents();
        if (response.data && response.data.responseBody) {
          const sortedEvents = [...response.data.responseBody].sort(
            (a, b) => getEventSortDate(a) - getEventSortDate(b),
          );
          setEvents(sortedEvents);
        }
      } catch (error) {
        toast.error("Failed to load events");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const handleRegisterClick = (event) => {
    navigate("/register-now", {
      state: {
        city: event.city,
        date: formatEventDisplayDate(event),
        euid: event.euid || "",
      },
    });
  };

  const handleUpcomingClick = (event) => {
    toast.info(`Registration for ${event.city} event will open soon!`);
  };

  const handleKnowMoreClick = (event) => {
    navigate("/platform-page", {
      state: {
        city: event.city,
        date: formatEventDisplayDate(event),
      },
    });
  };

  const upcomingEvents = events.filter((event) => !isEventPast(event));
  const pastEvents = events.filter((event) => isEventPast(event));

  return (
    <div className="paltform-gallery-page">
      {/* Hero Section */}
      <div
        className="paltform-gallery-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <h1 className="paltform-gallery-title">PLATFORMS</h1>
      </div>

      {/* Main Content Area */}
      <div className="city-section">
        {/* Upcoming Platforms */}
        <div className="platform-section-container">
          <h2 className="platform-section-title">Upcoming Platforms</h2>
          <div className="platform-gallery-wrapper">
            {loading ? (
              <p className="no-events-text">Loading events...</p>
            ) : upcomingEvents.length > 0 ? (
              <div className="platform-gallery-scroll-container">
                {upcomingEvents.map((event, index) => (
                  <div key={index} className="platform-gallery-item">
                    <div className="platform-info">
                      <p className="platform-platform-text">
                        {event.city} Chapter | <br />
                        {formatEventDisplayDate(event)}
                      </p>

                      {isEventWithinMonths(event, 3) ? (
                        <button
                          className="platform-button"
                          onClick={() => handleRegisterClick(event)}
                        >
                          Register now
                        </button>
                      ) : (
                        <button
                          className="platform-button"
                          onClick={() => handleUpcomingClick(event)}
                        >
                          Upcoming
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-events-text">No upcoming platforms scheduled.</p>
            )}
          </div>
        </div>

        {/* Explore Past Button */}
        <div className="explore-past-container">
          <button
            className="explore-past-btn"
            onClick={() => {
              const pastSection = document.getElementById("past-platforms");
              if (pastSection)
                pastSection.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Explore Past Platform <span>&rarr;</span>
          </button>
        </div>

        {/* Past Platforms */}
        <div id="past-platforms" className="platform-section-container">
          <h2 className="platform-section-title">Past Platforms</h2>
          <div className="platform-gallery-wrapper">
            {loading ? (
              <p className="no-events-text">Loading events...</p>
            ) : pastEvents.length > 0 ? (
              <div className="platform-gallery-scroll-container">
                {pastEvents.map((event, index) => (
                  <div key={index} className="platform-gallery-item">
                    <div className="platform-info">
                      <p className="platform-platform-text">
                        {event.city} |{" "}
                        {formatEventDisplayDate(event)}
                      </p>
                      <button
                        className="platform-button"
                        onClick={() => handleKnowMoreClick(event)}
                      >
                        Know More
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-events-text">No past platforms found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformPage;
